module.exports = __webpack_public_path__ + "static/media/logo-argañosa.91e8f7e6.jpg";